// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2o5gI","logo--inline":"Logo_logo--inline__3Dj3s","logo__img":"Logo_logo__img__3BtZD"};